import {
  Types,
} from '@jumpcloud/ui-components';

const { Column } = Types;

export const columns = {
  name: 'name',
  email: 'email',
  itemsCount: 'itemsCount',
  groups: 'groups',
  status: 'status',
  passwordHealth: 'passwordHealth',
  weakPasswords: 'weakPasswords',
  oldPasswords: 'oldPasswords',
  actions: 'actions',
};

const columnsMap = {
  [columns.name]: {
    label: 'Name',
    dataFieldName: 'name',
    sortable: true,
    width: '1fr',
  },
  [columns.email]: {
    label: 'Email',
    dataFieldName: 'email',
    sortable: true,
    width: '2fr',
  },
  [columns.itemsCount]: {
    label: 'Items Count',
    dataFieldName: 'itemsCount',
    sortable: false,
    width: '1fr',
  },
  [columns.groups]: {
    label: 'Groups',
    dataFieldName: 'groups',
    sortable: false,
    width: '1fr',
  },
  [columns.status]: {
    label: 'Service Status',
    dataFieldName: 'status',
    sortable: false,
    width: '1fr',
  },
  [columns.passwordHealth]: {
    label: 'Password Health',
    dataFieldName: 'passwordsScore',
    sortable: true,
    width: '160px',
  },
  [columns.weakPasswords]: {
    label: 'Weak Passwords',
    dataFieldName: 'weakPasswords',
    sortable: true,
    width: '1fr',
  },
  [columns.oldPasswords]: {
    label: 'Old Passwords',
    dataFieldName: 'oldPasswords',
    sortable: true,
    width: '1fr',
  },
  [columns.actions]: {
    label: '',
    sortable: false,
    width: '1fr',
  },
};

/**
 * @param {Array} columns
 * @returns {Array<Column>}
 */
export const getVisibleColumns = (excludedColumns) => Object.values(
  columns,
).map(currentColumn => Column({
  ...columnsMap[currentColumn],
  visible: !excludedColumns.includes(currentColumn),
}));

export default {
  columns,
  getVisibleColumns,
};
